import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();
const { COMMIT_HASH, ROOT_URL_PREFIX } = publicRuntimeConfig;

export const getOptionAssetURL = (path, preconfiguration) => {
  if (!path.startsWith("/")) {
    throw new Error(
      `Bad pathname format provided. Expected relativePath (i.e. "/asset"), but got "${path}"`
    );
  }

  const targetUrl = [
    ROOT_URL_PREFIX,
    `/images/option/${preconfiguration}`,
    path,
    `?version=${COMMIT_HASH}`,
  ].join("");

  return targetUrl;
};
